<template>
    <AnimationWrapper is-final-section>
        <template #animationContent>
            <div v-if="section.cta && section.cta.show" :class="['ufo--cta-btn-wr', alignment]">
                <a v-if="isExternalAnchor"
                   :href="ctaActionValue"
                   :target="[urlIsOwnDomain(ctaActionValue) ? '_self': '_blank']"
                   rel="nofollow noopener"
                   :class="['btn', 'btn--cta', ctaStyles?.[ctaType]?.fillStyle, ctaStyles?.[ctaType]?.shape, ctaStyles?.[ctaType]?.size, ctaType]"
                >
                    <span class="cta-content">
                        <span class="cta-label">{{ section.cta.title }}</span>
                        <Icon v-if="showActionIcon" class="cta-icon" :icon-name="ctaIconName" />
                    </span>
                </a>
                <button v-else
                        :type="formSubmitButton ? 'submit' : ''"
                        :class="['btn', 'btn--cta', ctaStyles?.[ctaType]?.fillStyle, ctaStyles?.[ctaType]?.shape, ctaStyles?.[ctaType]?.size, ctaType]"
                        @click="handleCtaClick()"
                >
                    <span class="cta-content">
                        <span class="cta-label">{{ section.cta.title }}</span>
                        <Icon v-if="showActionIcon" class="cta-icon" :icon-name="ctaIconName" />
                    </span>
                </button>
            </div>
        </template>
    </AnimationWrapper>
</template>

<script>
import AnimationWrapper from "../../../../common/components/AnimationWrapper.vue";
import {mapGetters} from "vuex";
import Icon from "@/scripts/common/Icon.vue";
import ctaButtonMixin from "@/scripts/common/mixins/ctaButtonMixin.js";

export default {
    name: "CtaButton",
    mixins: [ctaButtonMixin],
    components: {AnimationWrapper, Icon},
    props:{
        'section': {
            required: true
        },
        'formSubmitButton': {
            type:Boolean,
            required: true,
            default:false,
        },
        'alignment': {
            type:String,
            default:''
        }
    },
    methods: {
        handleCtaClick() {
            if (this.formSubmitButton) return;
            if (this.ctaActionType === "copy-email") {
                this.copyEmailToClipboard();
                return;
            }
            if (this.ctaActionValue) {
                this.handleNavigation();
            }
        },
        handleNavigation() {
            if (!this.ctaActionValue) return;

            if (this.ctaActionType === "open-resume") {
                window.open(this.ctaActionValue, "_blank");
                return;
            }

            if(this.ctaActionValue && !this.ctaActionValue.includes('/p/')) {
                this.ctaIntNavigation(this.ctaActionValue)
            }
            else {
                this.navigateToProject(this.ctaActionValue)
            }
        },
        ctaIntNavigation(page) {
            const { ownDomainAddress, shortId } = this.portfolio;
            const cleanPage = page.replace(/^\//, "");

            if (ownDomainAddress && ownDomainAddress !== location.host) {
                location.href = `${location.protocol}//${ownDomainAddress}` + (cleanPage ? `/${cleanPage}` : "");
                return;
            }
            const path = cleanPage && cleanPage !== shortId ? `/${shortId}/${cleanPage}` : `/${shortId}`;
            this.$router.push(path).then(() => {
                window.scrollTo(0,0);
            })
        },
        navigateToProject(projectUrl) {
            this.$router.push(projectUrl).then(() => {
                window.scrollTo(0, 0);
            });
        },
        copyEmailToClipboard() {
            const email = (this.ctaActionValue || "").replace(/^mailto:/i, "").trim();
            if (!email) return;

            if (navigator?.clipboard?.writeText) {
                navigator.clipboard.writeText(email).catch(() => {});
            }
            this.isCopied = true;
            if (this.copyIconTimer) clearTimeout(this.copyIconTimer);
            this.copyIconTimer = setTimeout(() => {
                this.isCopied = false;
            }, 5000);
        },
        urlIsOwnDomain(url) {
            return this.portfolio?.ownDomainAddress && this.portfolio.ownDomainAddress === url.replace(/^https?\:\/\//i, "");
        }
    },
    computed: {
        ...mapGetters("design", ["ctaStyles"]),
        ...mapGetters("view", ["viewData"]),
        isExternalAnchor() {
            if (this.formSubmitButton) return false;
            if (this.ctaActionType === "copy-email") return false;
            if (!this.ctaActionValue) return false;

            return this.ctaActionType === "open-resume"
                || this.ctaActionValue.includes("http://")
                || this.ctaActionValue.includes("https://")
                || this.ctaActionValue.includes("mailto:");
        },
        ctaIconName() {
            return this.getCtaActionIconName({isCopied: this.isCopied});
        },
        project() {
            return this.viewData.project;
        },
        portfolio() {
            return this.viewData.portfolio
        }
    },
    data() {
        return {
            isCopied: false,
            copyIconTimer: null,
        };
    },
    beforeUnmount() {
        if (this.copyIconTimer) {
            clearTimeout(this.copyIconTimer);
        }
    }
}
</script>
